"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9629],{

/***/ 370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.2.2A6.67 6.67 0 0 0 7 .197c-3.84 0-7 3.16-7 7V7.2c0 4.5 4.3 7.7 6.7 12.4.1.2.5.2.6 0 2.2-4.2 5.9-7 6.6-11 .108-.493.163-.996.163-1.501C14.063 3.31 10.988.174 7.2.1v.1ZM7 11c-2.03 0-3.7-1.67-3.7-3.7 0-2.03 1.67-3.7 3.7-3.7 2.03 0 3.7 1.67 3.7 3.7C10.7 9.33 9.03 11 7 11Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPin);

/***/ }),

/***/ 86022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDirectionArrow = function SvgDirectionArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.7 0c-.2 0-.4.3-.4.5V3H.7c-.3 0-.6.3-.6.7v2.5c0 .3.3.6.6.6h8.6v2.5c0 .2.2.5.4.6l.7-.1 5.3-4.4.2-.5c0-.2 0-.3-.2-.4L10.4 0a.7.7 0 0 0-.7-.1z",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDirectionArrow);

/***/ }),

/***/ 70173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
;// CONCATENATED MODULE: ./src/components/atoms/card/card.style.tsx

var StyledCardWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ur89tp0"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";border:1px solid ", function (props) {
  return props.theme.shades.lightMidGrey;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";width:100%;display:flex;flex-direction:", function (props) {
  return props.flexDirection;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/card/card.tsx



var Card = function Card(_ref) {
  var _ref$flexDirection = _ref.flexDirection,
      flexDirection = _ref$flexDirection === void 0 ? 'column' : _ref$flexDirection,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardWrapper, {
    "data-testid": 'card-component',
    flexDirection: flexDirection,
    children: children
  });
};

/***/ }),

/***/ 69252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ formatOfferTitle; }
/* harmony export */ });
var formatOfferTitle = function formatOfferTitle(offerTitle, startHarbour, shipName, numOfNights) {
  var replacementMap = {
    '[xharbour]': startHarbour,
    '[xship]': shipName,
    '[xduration]': numOfNights
  };
  return offerTitle.replace(/\[(([A-Za-z0-9#]+\s?))+]/g, function (matched) {
    return replacementMap[matched];
  });
};

/***/ }),

/***/ 95550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MA": function() { return /* binding */ StyledButtonWrapper; },
/* harmony export */   "Oc": function() { return /* binding */ StyledCardsWrapper; },
/* harmony export */   "T1": function() { return /* binding */ StyledCardsComponent; },
/* harmony export */   "pe": function() { return /* binding */ StyledTeaserWrapper; },
/* harmony export */   "r8": function() { return /* binding */ StyledHeaderWrapper; },
/* harmony export */   "sx": function() { return /* binding */ StyledOuterWrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61516);
/* harmony import */ var _style_global_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43780);
/* harmony import */ var _molecules_offer_board_card_offer_board_card_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50911);
/* harmony import */ var _components_atoms_section_headline_section_headline_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48957);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var StyledOuterWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "evhkbxz5"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";" + ( true ? "" : 0));
var StyledHeaderWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "evhkbxz4"
} : 0)(_components_atoms_section_headline_section_headline_style__WEBPACK_IMPORTED_MODULE_3__/* .StyledHeader */ .e, "{@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{padding-top:30px;padding-bottom:0;background-color:transparent;}}" + ( true ? "" : 0));
var StyledTeaserWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "evhkbxz3"
} : 0)("padding-bottom:30px;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{padding-top:30px;}" + ( true ? "" : 0));
var StyledCardsWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "evhkbxz2"
} : 0)("margin:auto;max-width:calc(100% - 20px);@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tablet */ .w5.tablet, "{margin:0 auto;max-width:calc(100% - 30px);}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.smallDesktopAndUp */ .w5.smallDesktopAndUp, "{max-width:1184px;}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.smallDesktop */ .w5.smallDesktop, " and (orientation: landscape){margin:0 auto;padding-left:", function (props) {
  return props.theme.spacing.large;
}, ";padding-right:", function (props) {
  return props.theme.spacing.large;
}, ";}" + ( true ? "" : 0));
var StyledCardsComponent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "evhkbxz1"
} : 0)("display:flex;align-items:center;flex-direction:row;flex-wrap:nowrap;overflow-x:auto;padding:20px 0 10px 0;margin:0 auto;align-items:stretch;justify-content:flex-start;width:100%;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.smallDesktopAndUp */ .w5.smallDesktopAndUp, "{justify-content:", function (props) {
  return props.count < 3 ? "center" : "flex-start";
}, ";flex-wrap:wrap;overflow-x:none;}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tablet */ .w5.tablet, "{", _molecules_offer_board_card_offer_board_card_style__WEBPACK_IMPORTED_MODULE_2__/* .StyledOfferBoardCard */ .YC, "{min-width:42%;}}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.phone */ .w5.phone, "{", _molecules_offer_board_card_offer_board_card_style__WEBPACK_IMPORTED_MODULE_2__/* .StyledOfferBoardCard */ .YC, "{min-width:85%;}}" + ( true ? "" : 0));
var StyledButtonWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "evhkbxz0"
} : 0)( true ? {
  name: "1cybdf7",
  styles: "text-align:center;&& div button span:first-child{padding-left:12px!important;}"
} : 0);

/***/ }),

/***/ 39045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ OfferTeaserMod; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/molecules/cruise-search-mask/utils.ts + 1 modules
var utils = __webpack_require__(47156);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/components/atoms/section-headline/section-headline.tsx
var section_headline = __webpack_require__(87080);
// EXTERNAL MODULE: ./src/contexts/device/device.tsx
var device_device = __webpack_require__(90780);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./src/utils/EventTracker.ts
var EventTracker = __webpack_require__(6946);
// EXTERNAL MODULE: ./src/utils/formatting.ts
var formatting = __webpack_require__(62556);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
// EXTERNAL MODULE: ./src/utils/dreamlines-formatter.ts
var dreamlines_formatter = __webpack_require__(61325);
// EXTERNAL MODULE: ./src/components/atoms/card/card.tsx + 1 modules
var card = __webpack_require__(70173);
// EXTERNAL MODULE: ./src/components/atoms/image/image.tsx + 2 modules
var image_image = __webpack_require__(87647);
// EXTERNAL MODULE: ./src/components/atoms/label-box/label-box.tsx + 6 modules
var label_box = __webpack_require__(61128);
// EXTERNAL MODULE: ./src/components/atoms/rating/rating.tsx + 3 modules
var rating = __webpack_require__(58761);
// EXTERNAL MODULE: ./src/components/atoms/simple-gallery/simple-gallery.tsx + 1 modules
var simple_gallery = __webpack_require__(11178);
// EXTERNAL MODULE: ./src/components/molecules/price/index.ts
var price = __webpack_require__(23554);
// EXTERNAL MODULE: ./src/components/molecules/offer-board-card/offer-board-card.style.tsx
var offer_board_card_style = __webpack_require__(50911);
// EXTERNAL MODULE: ./src/components/molecules/offer-board-card/offer-label.utils.ts
var offer_label_utils = __webpack_require__(69252);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/offer-board-card/offer-board-card.tsx





 // import { cabinMapper } from '../../../utils/mappings';













var OfferBoardCard = function OfferBoardCard(props) {
  var images = props.images,
      shipName = props.shipName,
      companyLogo = props.companyLogo,
      companyName = props.companyName,
      redirectUrl = props.redirectUrl,
      numOfNights = props.numOfNights,
      numOfDaysAtSea = props.numOfDaysAtSea,
      numOfSails = props.numOfSails,
      numOfPorts = props.numOfPorts,
      ratingValue = props.ratingValue,
      ratingString = props.ratingString,
      ratingCount = props.ratingCount,
      startHarbour = props.startHarbour,
      onBoardCredit = props.onBoardCredit,
      totalStock = props.totalStock,
      departureDate = props.departureDate,
      returnDate = props.returnDate,
      minPrice = props.minPrice,
      discount = props.discount,
      withFlight = props.withFlight,
      textLabelItems = props.textLabelItems,
      visits = props.visits,
      cabinStockThreshold = props.cabinStockThreshold,
      highDemand = props.highDemand,
      icons = props.icons,
      cardNum = props.cardNum;
  var formattedNumberOfNights = (0,dreamlines_formatter/* formatNumberOfNights */.h5)(numOfNights);
  var formattedOfferTitle = startHarbour && shipName && (0,offer_label_utils/* formatOfferTitle */.i)((0,translation_service.__)('offerTitle'), startHarbour, shipName, formattedNumberOfNights);

  var formattedHighDemand = highDemand && (0,translation_service.__)('highDemand').replace(/\[x]/g, String(visits));

  var cabinsLeftTranslation = !!totalStock && totalStock > 1 ? (0,translation_service.__)('cabinsLeft') : (0,translation_service.__)('cabinLeft');
  var formattedCabinsLeft = !!totalStock && totalStock < cabinStockThreshold && cabinsLeftTranslation.replace('[totalStock]', String(totalStock));

  var formattedOnBoardCredit = !!onBoardCredit && (0,translation_service.__)('OBCLabel').replace('[onBoardCredit]', String(onBoardCredit));

  var nightsPortsDaysAtSea = (0,dreamlines_formatter/* formatItineraryInfo */.p_)(numOfNights, numOfPorts, numOfDaysAtSea);
  cabinsLeftTranslation.replace('[totalStock]', String(totalStock));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledOfferBoardCard */.YC, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(card/* Card */.Z, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledTopSection */.zV, {
        children: [images.length > 1 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(simple_gallery/* SimpleGallery */.P, {
          showShadow: true,
          children: images.map(function (image, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledImageWrapper */.zT, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledAspectRatio */.eZ, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledContentWrapper */.H6, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_image/* NextImage */.o, {
                    imgUrl: image.url,
                    placeholder: image.url,
                    width: image.width,
                    height: image.height,
                    alt: 'An image of ' + shipName + ' ship'
                  })
                })
              })
            }, index);
          })
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledImageWrapper */.zT, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledAspectRatio */.eZ, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledContentWrapper */.H6, {
              children: images[0] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_image/* NextImage */.o, {
                imgUrl: images[0].url,
                placeholder: images[0].url,
                width: images[0].width,
                height: images[0].height,
                alt: 'An image of ' + shipName + ' ship'
              })
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledCompanyLogoWrapper */.Lh, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledImage */.Yo, {
            src: companyLogo,
            alt: "Logo of ".concat(companyName)
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledMiddleSection */.Q2, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledFlexSpaceBetween */.ez, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledItineraryInfo */.ad, {
            children: nightsPortsDaysAtSea
          }), Boolean(ratingValue) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(rating/* Rating */.i, {
            value: ratingValue,
            string: ratingString,
            amount: ratingCount
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledFlexSpaceBetween */.ez, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledOfferHeading */.F5, {
            href: redirectUrl,
            "aria-label": formattedOfferTitle,
            children: formattedOfferTitle
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledFlex */.G, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledDurationInfo */.uD, {
            children: (0,date/* formatDepartureReturn */.Yi)(departureDate, returnDate, numOfSails === 1)
          }), numOfSails > 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledEventsInfo */.fW, {
            children: "".concat(numOfSails, " ").concat((0,translation_service.__)('events'))
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledFlexSpaceBetween */.ez, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledMarketingLabels */.Wj, {
            children: [!!formattedCabinsLeft && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledMarketingOfferLabel */.Tb, {
              color: global_style/* theme.labels.onlineBookable */.rS.labels.onlineBookable,
              children: formattedCabinsLeft
            }), !!formattedOnBoardCredit && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledMarketingOfferLabel */.Tb, {
              color: global_style/* theme.colors.discountSpecial */.rS.colors.discountSpecial,
              children: formattedOnBoardCredit
            }), !!formattedHighDemand && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledMarketingOfferLabel */.Tb, {
              color: global_style/* theme.labels.urgency */.rS.labels.urgency,
              children: formattedHighDemand
            })]
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledBottomSection */.nn, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledFlexSpaceBetween */.ez, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledIconList */.wT, {
            children: icons.map(function (icon, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_board_card_style/* StyledIconListItem */.T8, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledCheckMarkIcon */.Uv, {}), (0,translation_service.__)(icon.text)]
              }, index);
            })
          })
        }), textLabelItems !== null && textLabelItems !== void 0 && textLabelItems.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledUserLove */.dR, {
            children: (0,translation_service.__)('userLove')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledTextLabelList */.hE, {
            children: textLabelItems.map(function (textLabel, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledTextLabelListItem */.UN, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(label_box/* LabelBox */.q, {
                  type: textLabel.label,
                  label: (0,translation_service.__)(textLabel.label)
                })
              }, index);
            })
          })]
        }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledMargin */.BL, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(price/* Price */.t, {
            price: Number(minPrice.toFixed(0)),
            discount: discount,
            withFlight: withFlight,
            onRequest: !minPrice,
            size: 'S'
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledButtonWrapper */.MA, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
            primary: true,
            wrapperStyle: {
              width: '100%',
              padding: '0 10px'
            },
            style: {
              textDecoration: 'none'
            },
            redirectUrl: redirectUrl,
            onClick: function onClick() {
              handleClick(props.requestType, props.shipName, cardNum);
              router_default().push(redirectUrl);
            },
            domType: "a",
            children: (0,translation_service.__)('seeOffers')
          })
        })]
      })]
    })
  });
};

var handleClick = function handleClick(type, title, cardNum) {
  return EventTracker/* eventTracker.track */.xT.track({
    event: 'click',
    category: 'offers-teasers',
    action: "teaser-".concat(cardNum),
    label: "".concat(type, "-").concat(title)
  });
};
// EXTERNAL MODULE: ./src/components/sections/offer-teaser/offer-teaser.style.tsx
var offer_teaser_style = __webpack_require__(95550);
;// CONCATENATED MODULE: ./src/components/sections/offer-teaser/offer-teaser.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var OfferTeaser = function OfferTeaser(props) {
  var totalOfferCount = props.totalOfferCount,
      headline = props.headline,
      items = props.items,
      requestType = props.requestType,
      searchUrl = props.searchUrl;
  var formattedOfferCount = totalOfferCount && totalOfferCount > 0 && (0,formatting/* replaceVal */.yy)((0,translation_service.__)('seeAllOffers'), (0,formatting/* numberFormat */.Y4)(totalOfferCount));
  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var limit = device === 'mobile' ? 3 : 6;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_teaser_style/* StyledOuterWrapper */.sx, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_teaser_style/* StyledHeaderWrapper */.r8, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(section_headline/* SectionHeadline */.A, {
        firstChunk: headline,
        secondChunk: (0,translation_service.__)('deals')
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(offer_teaser_style/* StyledTeaserWrapper */.pe, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_teaser_style/* StyledCardsWrapper */.Oc, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_teaser_style/* StyledCardsComponent */.T1, {
          count: totalOfferCount,
          children: items.map(function (el, i) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferBoardCard, _objectSpread(_objectSpread({}, el), {}, {
              requestType: requestType,
              cardNum: i + 1
            }), i);
          })
        })
      }), totalOfferCount > limit && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_teaser_style/* StyledButtonWrapper */.MA, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
          primary: true,
          style: {
            fontSize: global_style/* theme.fontSize.copyTextXL */.rS.fontSize.copyTextXL,
            fontWeight: 600,
            height: '45px',
            position: 'relative',
            padding: '6px 33px',
            cursor: 'pointer'
          },
          onClick: function onClick() {
            EventTracker/* eventTracker.track */.xT.track({
              event: 'click',
              category: 'offers-teasers',
              action: "all-offers-button",
              label: "".concat(requestType, "-").concat(headline)
            }); // @TODO Router is not working with full urls, find a solution later

            window.location.href = searchUrl;
          },
          domType: "div",
          children: formattedOfferCount
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/utils/normalizeLabels.ts
var normalizeLabels = __webpack_require__(22301);
;// CONCATENATED MODULE: ./src/utils/ugc-options.ts

function getRatingLabel(rating) {
  if (rating) {
    if (rating < 3) {
      return (0,translation_service.__)('ugcAverage');
    }

    if (rating < 4.5) {
      return (0,translation_service.__)('ugcOk');
    }

    if (rating < 7) {
      return (0,translation_service.__)('ugcGood');
    }

    if (rating < 8.5) {
      return (0,translation_service.__)('ugcVeryGood');
    }

    return (0,translation_service.__)('ugcExcellent');
  }

  return '';
}
// EXTERNAL MODULE: ./src/utils/url-generation.ts
var url_generation = __webpack_require__(46834);
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
;// CONCATENATED MODULE: ./src/modules/offer-teaser-mod.tsx










// getOfferItems function adding priorityCruise (Dreamlines packages) as a first item if it exists
var getOfferItems = function getOfferItems(items, priorityCruise) {
  if (!(priorityCruise !== null && priorityCruise !== void 0 && priorityCruise.length)) return items || [];
  var firstPriorityCruiseItem = priorityCruise[0];
  var currentOffersWithoutPriorityCruise = items.filter(function (item) {
    return item.cruiseId !== firstPriorityCruiseItem.cruiseId;
  });
  var mergedItems = [firstPriorityCruiseItem].concat((0,toConsumableArray/* default */.Z)(currentOffersWithoutPriorityCruise)); // remove the last item if we got more than six offers per page

  if (mergedItems.length > 6) {
    mergedItems.pop();
  }

  return mergedItems;
};

var OfferTeaserMod = function OfferTeaserMod(_ref) {
  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData,
      globalConfigData = _ref.globalConfigData;
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var baseUrl = "https://www.".concat(localeConfig.url, "/").concat(localeConfig.slugs.search);
  var filterType = encodeURIComponent('filterParams[ship][0]');
  var selection = {
    key: String(getLandingPage.id),
    title: ''
  };
  var sortType = 'sortString=' + localeConfig.defaultSortingString;
  var searchUrl = "".concat(baseUrl, "?").concat(sortType);

  if (getLandingPage.type === 'ship') {
    searchUrl = "".concat(baseUrl, "?").concat(filterType, "=").concat(getLandingPage.id, "&").concat(sortType);
  } else if (getLandingPage.type === 'cruiseline') {
    searchUrl = "".concat((0,utils/* createSearchUrl */.nM)(baseUrl, {
      brand: selection
    }), "&").concat(sortType);
  } else if (getLandingPage.type === 'destination') {
    searchUrl = "".concat((0,utils/* createSearchUrl */.nM)(baseUrl, {
      region: selection
    }), "&").concat(sortType);
  }

  if (!modulesData || !modulesData.cruiseSearchlandingpageOffer) return null;
  var _modulesData$cruiseSe = modulesData.cruiseSearchlandingpageOffer,
      totalCount = _modulesData$cruiseSe.totalCount,
      items = _modulesData$cruiseSe.items,
      priorityCruise = _modulesData$cruiseSe.priorityCruise;

  if (items.length < 1) {
    console.warn('cruise search in frontpage returned no offers for slug', getLandingPage.slug);
    return null;
  }

  var offerItems = getOfferItems(items, priorityCruise).map(function (item) {
    var _item$sailings, _item$sailings2, _item$startHarbour, _item$ship, _item$routeMeta, _item$routeMeta2, _item$brand, _item$brand2, _item$sailings3, _item$stats, _item$topSail, _item$topSail$rate, _item$sailings4, _item$sailings5, _item$sailings6, _item$sailings7;

    var shipImage = item.ship.images;
    var routeImages = item.images.filter(function (image) {
      return image.tags.includes('route');
    });
    var images = item.images.filter(function (image) {
      return !image.tags.includes('route');
    });
    var teaserImages = [].concat((0,toConsumableArray/* default */.Z)(routeImages), (0,toConsumableArray/* default */.Z)(shipImage), (0,toConsumableArray/* default */.Z)(images));
    var days = item.days;
    var sails = item === null || item === void 0 ? void 0 : (_item$sailings = item.sailings) === null || _item$sailings === void 0 ? void 0 : _item$sailings.sails;
    var defaultCabinAvailabilityMaxThreshold = 50;
    var cabinAvailabilityMaxThreshold = globalConfigData ? globalConfigData.cabinAvailabilityMaxThreshold : defaultCabinAvailabilityMaxThreshold;
    var price = (item === null || item === void 0 ? void 0 : (_item$sailings2 = item.sailings) === null || _item$sailings2 === void 0 ? void 0 : _item$sailings2.minPrice) || 0;
    var highDemandObj = item.ugcLabels && item.ugcLabels.find(function (ugcLabel) {
      return ugcLabel.label === 'highDemand';
    });
    return {
      nid: item.cruiseId,
      startHarbour: item === null || item === void 0 ? void 0 : (_item$startHarbour = item.startHarbour) === null || _item$startHarbour === void 0 ? void 0 : _item$startHarbour.city,
      shipName: item === null || item === void 0 ? void 0 : (_item$ship = item.ship) === null || _item$ship === void 0 ? void 0 : _item$ship.title,
      icons: item.icons,
      numOfNights: days > 1 ? days - 1 : '',
      numOfPorts: item === null || item === void 0 ? void 0 : (_item$routeMeta = item.routeMeta) === null || _item$routeMeta === void 0 ? void 0 : _item$routeMeta.uniqueStops,
      numOfDaysAtSea: item === null || item === void 0 ? void 0 : (_item$routeMeta2 = item.routeMeta) === null || _item$routeMeta2 === void 0 ? void 0 : _item$routeMeta2.daysAtSea,
      images: teaserImages,
      companyLogo: item === null || item === void 0 ? void 0 : (_item$brand = item.brand) === null || _item$brand === void 0 ? void 0 : _item$brand.logo,
      companyName: item === null || item === void 0 ? void 0 : (_item$brand2 = item.brand) === null || _item$brand2 === void 0 ? void 0 : _item$brand2.title,
      ratingValue: item.ratingStars ? item.ratingStars.toFixed(1) : undefined,
      ratingString: getRatingLabel(item.ratingStars),
      ratingCount: item.ratingCount,
      minPrice: price / 2,
      discount: item === null || item === void 0 ? void 0 : (_item$sailings3 = item.sailings) === null || _item$sailings3 === void 0 ? void 0 : _item$sailings3.maxDiscount,
      visits: item === null || item === void 0 ? void 0 : (_item$stats = item.stats) === null || _item$stats === void 0 ? void 0 : _item$stats.visits,
      cabinStockThreshold: cabinAvailabilityMaxThreshold,
      highDemand: Boolean(highDemandObj),
      cheapestCabinType: item === null || item === void 0 ? void 0 : (_item$topSail = item.topSail) === null || _item$topSail === void 0 ? void 0 : (_item$topSail$rate = _item$topSail.rate) === null || _item$topSail$rate === void 0 ? void 0 : _item$topSail$rate.cabinType,
      highlights: item.topHarboursHighlights || [],
      withFlight: item.includesFlight,
      departureDate: item === null || item === void 0 ? void 0 : (_item$sailings4 = item.sailings) === null || _item$sailings4 === void 0 ? void 0 : _item$sailings4.earliestDepartureDate,
      returnDate: item === null || item === void 0 ? void 0 : (_item$sailings5 = item.sailings) === null || _item$sailings5 === void 0 ? void 0 : _item$sailings5.latestReturnDate,
      totalStock: item === null || item === void 0 ? void 0 : (_item$sailings6 = item.sailings) === null || _item$sailings6 === void 0 ? void 0 : _item$sailings6.totalStock,
      onBoardCredit: item === null || item === void 0 ? void 0 : (_item$sailings7 = item.sailings) === null || _item$sailings7 === void 0 ? void 0 : _item$sailings7.onBoardCredit,
      numOfSails: sails ? sails.length : 0,
      textLabelItems: (0,normalizeLabels/* normalizeLabels */.Z)({
        ugcLabels: item.ugcLabels || [],
        excludeCluster: ['productData']
      }),
      redirectUrl: (0,url_generation/* generateCruiseUrl */.g)(localeConfig.slugs.cruise.prefix, item === null || item === void 0 ? void 0 : item.title, Number(item === null || item === void 0 ? void 0 : item.cruiseId)),
      requestType: getLandingPage.type
    };
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferTeaser, {
    totalOfferCount: totalCount,
    headline: getLandingPage.title // @TODO: there's a misalignement of props here
    ,
    items: offerItems,
    searchUrl: searchUrl,
    requestType: getLandingPage.type
  }, "offerTeaser");
};

/***/ }),

/***/ 61325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NK": function() { return /* binding */ formatMultipleLabels; },
/* harmony export */   "h5": function() { return /* binding */ formatNumberOfNights; },
/* harmony export */   "p_": function() { return /* binding */ formatItineraryInfo; }
/* harmony export */ });
/* harmony import */ var _translation_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21449);

var formatNumberOfNights = function formatNumberOfNights(numOfNights) {
  if (numOfNights && Number.isInteger(numOfNights) && numOfNights > 0) {
    return "".concat(numOfNights, " ").concat((0,_translation_service__WEBPACK_IMPORTED_MODULE_0__.__)(numOfNights === 1 ? 'night' : 'nights'));
  }

  return '';
};
var formatItineraryInfo = function formatItineraryInfo(numOfNights, numOfPorts, numOfDaysAtSea) {
  var acc = [];

  if (numOfNights && Number.isInteger(numOfNights) && numOfNights > 0) {
    acc.push("".concat(numOfNights, " ").concat((0,_translation_service__WEBPACK_IMPORTED_MODULE_0__.__)(numOfNights === 1 ? 'night' : 'nights')));
  }

  if (numOfPorts && Number.isInteger(numOfPorts) && numOfPorts > 0) {
    acc.push("".concat(numOfPorts, " ").concat((0,_translation_service__WEBPACK_IMPORTED_MODULE_0__.__)(numOfPorts === 1 ? 'port' : 'ports')));
  }

  if (numOfDaysAtSea && Number.isInteger(numOfDaysAtSea) && numOfDaysAtSea > 0) {
    acc.push("".concat(numOfDaysAtSea, " ").concat((0,_translation_service__WEBPACK_IMPORTED_MODULE_0__.__)(numOfDaysAtSea === 1 ? 'dayAtSea' : 'daysAtSea')));
  }

  return acc.join(', ');
};
var formatMultipleLabels = function formatMultipleLabels(text, mappedObject) {
  return text.replace(/\[(([A-Za-z0-9#]+\s?))+]/g, function (matched) {
    return mappedObject[matched] || '';
  });
};

/***/ }),

/***/ 22301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ normalizeLabels; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27812);
/* harmony import */ var _object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43711);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var labelsCluster = {
  productData: [{
    name: 'bestseller',
    priority: 3
  }, {
    name: 'highDemand',
    priority: 12
  }],
  shipRatings: [{
    name: 'shipRating',
    priority: 4
  }, {
    name: 'cabinRating',
    priority: 6
  }, {
    name: 'gastronomyRating',
    priority: 7
  }, {
    name: 'entertainmentRating',
    priority: 11
  }, {
    name: 'serviceRating',
    priority: 16
  }],
  experienceLabels: [{
    name: 'firstCruise',
    priority: 8,
    subpriority: 1
  }, {
    name: 'experiencedCruiseTraveler',
    priority: 8,
    subpriority: 2
  }],
  ageRange: [{
    name: 'ageRangeYoung',
    priority: 9,
    subpriority: 1
  }, {
    name: 'ageRangeSenior',
    priority: 9,
    subpriority: 2
  }],
  routeRatings: [{
    name: 'itineraryRating',
    priority: 5
  }, {
    name: 'excursionsRating',
    priority: 10
  }],
  constellation: [{
    name: 'constellationcouple',
    priority: 13,
    subpriority: 1
  }, {
    name: 'constellationfamily',
    priority: 13,
    subpriority: 2
  }, {
    name: 'constellationfamilysmallchildren',
    priority: 13,
    subpriority: 3
  }, {
    name: 'constellationsingle',
    priority: 13,
    subpriority: 4
  }, {
    name: 'constellationfriends',
    priority: 13,
    subpriority: 5
  }],
  atmosphere: [{
    name: 'atmospherefamiliar',
    priority: 14,
    subpriority: 1
  }, {
    name: 'atmosphererelaxed',
    priority: 14,
    subpriority: 2
  }, {
    name: 'atmospherechaotic',
    priority: 14,
    subpriority: 3
  }, {
    name: 'atmospherediverse',
    priority: 14,
    subpriority: 4
  }, {
    name: 'atmosphereelegant',
    priority: 14,
    subpriority: 5
  }, {
    name: 'atmosphereloud',
    priority: 14,
    subpriority: 6
  }, {
    name: 'atmosphereboring',
    priority: 14,
    subpriority: 7
  }],
  ugcReview: [{
    name: 'recommend',
    priority: 15
  }]
};
var normalizeLabels = function normalizeLabels(_ref) {
  var ugcLabels = _ref.ugcLabels,
      _ref$excludeCluster = _ref.excludeCluster,
      excludeCluster = _ref$excludeCluster === void 0 ? [] : _ref$excludeCluster;
  var prioritizedLabels = [];

  var _iterator = _createForOfIteratorHelper((0,_object_keys__WEBPACK_IMPORTED_MODULE_0__/* .objectKeys */ .Y)(labelsCluster)),
      _step;

  try {
    var _loop = function _loop() {
      var key = _step.value;
      var cluster = labelsCluster[key];
      var filteredLabelsClusterItems = cluster && !excludeCluster.includes(key) && cluster.filter(function (clusterItem) {
        return ugcLabels.some(function (ugcLabel) {
          var trimmedUGCLabel = ugcLabel.label && ugcLabel.label.replace(/[^a-zA-Z]/g, '');
          return trimmedUGCLabel === clusterItem.name;
        });
      });
      var mappedClusterItems = filteredLabelsClusterItems ? filteredLabelsClusterItems.map(function (label) {
        return {
          label: label.name,
          type: key
        };
      }) : [];
      filteredLabelsClusterItems && prioritizedLabels.push.apply(prioritizedLabels, (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(mappedClusterItems));
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return prioritizedLabels;
};

/***/ })

}]);